import { RtcDiagnosis, VideoCodec } from "./rtc_diagnosis";
import { createTraceInstance } from "../common/open_telemery";
import { v4 } from "uuid";
import Cookies from 'js-cookie';
import { SpanStatusCode } from "@opentelemetry/api";
const connectId = v4();
const userId = Cookies.get('userId');
function checkWebRTCCodec() {
    try {
        const rtcDiagnosis = new RtcDiagnosis();
        const tracerProvider = createTraceInstance({ connectId: connectId, userId: userId, UA: window.navigator.userAgent }, false);
        tracerProvider.startCodecSpans([VideoCodec.H264, VideoCodec.VP8]);
        rtcDiagnosis.addTransceivers(0, 2);
        rtcDiagnosis.exchangeSdp((_, _err) => {
        });
        rtcDiagnosis.checkSupportedVideoCodec((codecs, error) => {
            if (!error) {
                console.debug("Supported video codec:", codecs);
                // @ts-ignore
                if (!window.WebRTCVideoCodec) {
                    // @ts-ignore
                    window.WebRTCVideoCodec = codecs[0];
                }
                tracerProvider.endCodecSpan(codecs[0], SpanStatusCode.OK);
            }
            else {
                for (const codec of codecs) {
                    tracerProvider.endCodecSpan(codec, SpanStatusCode.ERROR);
                }
                // @ts-ignore if one of the codec is supported, stop iteration
                if (!window.WebRTCVideoCodec) {
                    //unlimited retry every 10s
                    checkWebRTCCodec();
                }
            }
        }, 10);
    }
    catch (error) {
        console.warn(error);
    }
}
checkWebRTCCodec();
